import { useState, useRef } from 'react';
import Slider from 'react-slick';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const photos = [
    "/compressed/IMG_1771-1-blue.jpg",
    "/compressed/yellow-flower-2500.jpg",
    "/compressed/IMG_1790-1.jpg",
    "/compressed/white-flower-2500.jpg",
    "/compressed/orange-little-flower-2500.jpg",
    "/compressed/white-dried-flower-2500.jpg",
    "/compressed/IMG_1793-1.jpg",
    "/compressed/red-flower-2500.jpg",
    "/compressed/crazySky.jpg",
    "/compressed/red-orange-flower-2500.jpg",
    "/compressed/IMG_1779-1crop.jpg",
];

export default function PhotoCarousel() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);

    const settings = {
        lazyLoad: true,
        infinite: true,
        centerMode: true,
        centerPadding: "20%",
        slidesToShow: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 2000,
        cssEase: "ease-in-out",
        beforeChange: (current, next) => setCurrentSlide(next),
    };

    const handleWheel = (e) => {
        e.preventDefault();
        if (e.deltaY > 0) {
            sliderRef.current.slickNext();
        } else {
            sliderRef.current.slickPrev();
        }
    };

    return (
        <div className="w-full h-full overflow-hidden" onWheel={handleWheel}>
            <Slider ref={sliderRef} {...settings}>
                {photos.map((photo, index) => (
                    <div key={index} className="px-2">
                        <div className="h-full w-full flex justify-center items-center">
                            <img
                                src={photo}
                                alt={`Photo ${index + 1}`}
                                className={`h-[25vh] w-[90vw] sm:h-[35vh] sm:w-[90vw] transition-all duration-400 object-cover
                                  ${currentSlide === index
                                        ? 'opacity-100 blur-0 scale-100 filter sm:hover:grayscale-0'
                                        : 'opacity-50 blur-xs scale-95 filter grayscale sm:grayscale'}`}
                            />
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    )
}
